module.exports = __webpack_public_path__ + "media/images/training_bg_image-fc9d856aeffe97e184024bd6ce80bcbd.jpg";